import ImageTitleAndDescription from "../components/Item/variants/ImageTitleAndDescription";
import ImageAndTooltip from "../components/Item/variants/ImageAndTooltip";
import ImageAndTitle from "../components/Item/variants/ImageAndTitle";
import { DisplayType } from "../types";

export const getTopperVariant = (displayType: number) =>
  ({
    [DisplayType.ImageTitleAndDescription]: ImageTitleAndDescription,
    [DisplayType.ImageAndTooltip]: ImageAndTooltip,
    [DisplayType.ImageAndTitle]: ImageAndTitle,
  })[[1, 2].includes(displayType) ? 1 : displayType.toString()];
